/**=========================================================
 * Module: app-spinner.js
 * Spinner
 =========================================================*/

 App.directive('appFileicon', function(){
  'use strict';

  return {
      templateUrl: '/app/views/partials/fileicon.html',
      controller: 'FileIconController',
      restrict: 'E',
      replace: true,
      scope: {
        extension: '@extension',
        filepath: '@filepath',
        suffix: '@suffix',
        mode: '@mode',
        selectorOptions: '='
      }
  };

});